import { render, staticRenderFns } from "./complianceBase.vue?vue&type=template&id=0aa58665"
import script from "./complianceBase.vue?vue&type=script&lang=js"
export * from "./complianceBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports